<template>
  <section class="flex block__slideout block__slideout_notifications">
    <b-row class="block__notification">
      <!-- ENTETE -->
      <div class="mobile">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
              <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h3>{{general.notificationsTitle}}</h3>
        </div>
        <div class="sep"></div>
      </div>
      <!-- ENTETE -->


      <!-- CONTENT -->
      <div class="scrollable">
        <div class="entete col">
          <h1>{{general.notificationsTitle}}</h1>
        </div>

        <div class="col">
          <b-list-group>
            <PuSkeleton :loading="isLoading" width="50%">                
              <div class="date">08 avril 2020</div>
            </PuSkeleton>
            <b-list-group-item>
              <CardNotification type="positif" title="Objectif positif" subtitle="Féliciations"></CardNotification>
            </b-list-group-item>
            <b-list-group-item>
              <CardNotification type="negatif" title="Objectif négatif" subtitle="Oups !"></CardNotification>
            </b-list-group-item>
            <b-list-group-item>
              <CardNotification type="done" title="Objectif"></CardNotification>
            </b-list-group-item>
              <Stack></Stack>
            <PuSkeleton :loading="isLoading" width="50%">                
              <div class="date">08 avril 2020</div>
            </PuSkeleton>
            <b-list-group-item>
              <CardNotification type="positif" title="Objectif positif"  subtitle="Féliciations"></CardNotification>
            </b-list-group-item>
              <Stack></Stack>
            <PuSkeleton :loading="isLoading" width="50%">                
              <div class="date">03 avril 2020</div>
            </PuSkeleton>
            <b-list-group-item>
              <CardNotificationContest type="positif" title="Objectif positif" ></CardNotificationContest>
            </b-list-group-item>
              <Stack></Stack>
            <PuSkeleton :loading="isLoading" width="50%">                
              <div class="date">03 avril 2020</div>
            </PuSkeleton>
            <b-list-group-item>
              <CardNotificationContest type="positif" title="Objectif positif"></CardNotificationContest>
            </b-list-group-item>
              <Stack></Stack>
          </b-list-group>
        </div>
      </div>
      <!-- CONTENT -->


    </b-row>

  </section>
</template>




<script>
import { mapGetters } from 'vuex'
import ParentMixin from '../../ParentMixin'
import CardNotification from '../../../../components/module/card/CardNotification'
import CardNotificationContest from '../../../../components/module/card/CardNotificationContest'
import Stack from '../../../../components/module/stack/Stack'

export default {
    name:"notificationsHome",
    components:{ 
      CardNotification,
      CardNotificationContest,
      Stack     
    }, 
    mixins:[
      ParentMixin
    ],
    computed: {
      ...mapGetters([
        'getGeneral',
      ])
    },
    data () {
      return {
        general:"",
        isLoading:true,
      }
    },
    created (){
      this.general = this.getGeneral;

    setTimeout(() => {
        this.isLoading = false;
      },2000)         
    },    
    methods : {
      goBack() {
        this.$router.push({name: "home"});  
      },
    }
};
</script>
